import { useEffect, useState } from 'react';
import AssessmentResponseHeader from '../../../Components/Headers/AssessmentResponseHeader';
import getAssessmentTitle from '../../SupplierPage/Utilities/getAssessmentTitle';
import getAssessmentResponse from '../Utilities/getAssessmentResponse';
import ResponseItem from '../Subcomponents/AssessmentResponseItem'; 
import styles from '../AssessmentResponse.module.css';
import ResponseDate from '../Subcomponents/ReponseDate';

// Shows the responses that a supplier gave to Assessment10004.
const Assessment10004Response = ( {assessmentid} ) => {
  const title = getAssessmentTitle(10004);
  const [assessmentResponse, setAssessmentResponse] = useState(null);

  useEffect(() => {
    async function getResponseInfo() {
      const incomingResponse = await getAssessmentResponse('supplier_assessment_10004', assessmentid);
      setAssessmentResponse(incomingResponse);
    }
    getResponseInfo()

  }, [assessmentid]);

  // Blank component until assessmentResponse has a value from
  // the DB call.
  if (!assessmentResponse) return null;

  return(
    <main className={styles.assessmentresponsemain}>
      <div className={styles.assessmentresponsecontentwrapper}>
        <AssessmentResponseHeader title={title} />
        <ResponseItem 
          question='Company Name'
          answer={assessmentResponse['company_name']}         
        />
        <ResponseItem 
          question='Does your company know it’s Scope 2 emissions?'
          answer={assessmentResponse['scope_2_emissions']}         
        />
        <ResponseItem 
          question='What are your annual Scope 2 emissions (metric tons of CO2 equivalent)?'
          answer={assessmentResponse['annual_scope_emissions']}         
        />
        <ResponseItem 
          question='Which year does this represent?'
          answer={assessmentResponse['representational_year']}         
        />
        <ResponseItem 
          question='Calendar or fiscal year?'
          answer={assessmentResponse['calendar_or_fiscal_year']}         
        />
        <ResponseItem 
          question='What percentage of your company&#39;s Scope 2 emissions should be allocated to this customer?'
          answer={assessmentResponse['allocation_percentage']}         
        />
        <ResponseDate 
          assessmentResponse={assessmentResponse} 
        />
      </div>
    </main>
  );
}

export default Assessment10004Response;